@if (territory) {
  @switch (displayMode) {
    @case ('flag') {
      <img [src]="'/assets/countries/' + territory.id.toLowerCase() + '.svg'"
           [alt]="'TERRITORIES.' + territory.id.toUpperCase() | translate"
           loading="eager"
           class="country-flag"
           [matTooltipClass]="{'uzai-tooltip': true}"
           [matTooltip]="'TERRITORIES.' + territory.id.toUpperCase() | translate"/>
    }
    @case ('name') {
      <span class="text">{{ 'TERRITORIES.' + territory.id.toUpperCase() | translate }}</span>
    }
    @case ('full') {
      <div class="country-full">
        <img [src]="'/assets/countries/' + territory.id.toLowerCase() + '.svg'"
             [alt]="'TERRITORIES.' + territory.id.toUpperCase() | translate"
             loading="eager"
             class="country-flag"/>
        <span class="text">{{ 'TERRITORIES.' + territory.id.toUpperCase() | translate }}</span>
      </div>
    }
  }
} @else if (wipoCode) {
  <span class="text">{{ wipoCode.toUpperCase() }}</span>
} @else {
  <span class="text">-</span>
}
